import clienteAxios from "../config/axios";

export const addField = async (field) => {
    return await clienteAxios.post('/activosXreport', {field});
}

export const getFieldsByReportName = async (reportName) => {
    return await clienteAxios.get(`/activosXreport/${reportName}`)
}